import { combineReducers } from "redux-immutable";

import { makeCrudStateReducer } from "seneca-common/utils/apiStates";

import {
  childClassEnrollmentsCrudConfig,
  classEnrollmentsCrudConfig
} from "../consts";
import ClassEnrollmentsStateSlice from "../models/ClassEnrollmentsStateSlice";

const classEnrollmentsCrudStateReducer = makeCrudStateReducer(
  classEnrollmentsCrudConfig
);

export const childClassEnrollmentsCrudStateReducer = makeCrudStateReducer(
  childClassEnrollmentsCrudConfig
);

export default combineReducers(
  {
    studentClassEnrollments: classEnrollmentsCrudStateReducer,
    childClassEnrollments: childClassEnrollmentsCrudStateReducer
  },
  () => new ClassEnrollmentsStateSlice() as any
);
